import _classCallCheck from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  position: absolute;\n  right: 0;\n  top: 0;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  ", "\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding-right: ", "px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  align-items: center;\n  display: flex;\n  padding-right: 0;\n  width: 100%;\n\n  &::after {\n    background-color: ", ";\n    bottom: 6px;\n    content: '';\n    height: 2px;\n    left: ", "px;\n    position: absolute;\n    right: ", "px;\n    transform: scaleX(", ");\n    transition: transform ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __rest } from "tslib";
import React, { Component } from 'react';
import styled from 'styled-components';
import { ellipsis } from 'polished';
import { color, property } from '@scp/ui-shared/theme/variables';
import { focusById } from '@scp/ui-shared/theme/utils';
import { ClearedButton } from '@scp/ui-shared/theme/resets';
import { Placeholder } from '@scp/ui-shared/components/typography';
import { FieldWrapper } from './FieldWrapper';
import { Label } from './Label';
import { FIELD_INNER_PADDING } from './constants';
import { ClearButton, TriggerButton, FieldBase } from './base';
var SelectUI = styled(FieldBase)(_templateObject(), color.action, FIELD_INNER_PADDING, FIELD_INNER_PADDING, function (props) {
  return props.fieldFocused ? 1 : 0;
}, property.transition);
var TriggerWrapper = styled.div(_templateObject2());
var Trigger = styled(SelectUI).attrs({
  type: 'button'
})(_templateObject3(), function (props) {
  return props.showClearIcon ? 80 : 40;
});
var ValueWrapper = styled.span(_templateObject4(), ellipsis());
var ActionsWrapper = styled.div(_templateObject5());
/**
 * A component which looks like `<select>` and is used for building Dropdown components like DatePickerField, TimePickerField
 *
 * @example ./__docs__/SelectTrigger.md
 */

export var SelectTrigger = /*#__PURE__*/function (_Component) {
  _inherits(SelectTrigger, _Component);

  var _super = _createSuper(SelectTrigger);

  function SelectTrigger() {
    var _this;

    _classCallCheck(this, SelectTrigger);

    _this = _super.apply(this, arguments);

    _this.handleBtnFocus = function () {
      return focusById("".concat(_this.props.id, "-arrow"));
    };

    return _this;
  }

  _createClass(SelectTrigger, [{
    key: "render",
    value: function render() {
      var _a = this.props,
          id = _a.id,
          title = _a.title,
          label = _a.label,
          value = _a.value,
          placeholder = _a.placeholder,
          errorText = _a.errorText,
          onClear = _a.onClear,
          onClick = _a.onClick,
          clearable = _a.clearable,
          disabled = _a.disabled,
          hiddenLabel = _a.hiddenLabel,
          hint = _a.hint,
          _a$hideError = _a.hideError,
          hideError = _a$hideError === void 0 ? false : _a$hideError,
          _a$truncateLabel = _a.truncateLabel,
          truncateLabel = _a$truncateLabel === void 0 ? false : _a$truncateLabel,
          isOptional = _a.isOptional,
          btnProps = __rest(_a, ["id", "title", "label", "value", "placeholder", "errorText", "onClear", "onClick", "clearable", "disabled", "hiddenLabel", "hint", "hideError", "truncateLabel", "isOptional"]);

      var showClearIcon = clearable && !!value;
      return React.createElement(FieldWrapper, {
        id: id,
        errorText: errorText,
        hint: hint,
        hideError: hideError
      }, React.createElement(Label, {
        as: "span",
        disabled: disabled,
        visuallyHidden: hiddenLabel,
        onClick: onClick,
        id: "".concat(id, "-label"),
        truncate: truncateLabel,
        isOptional: isOptional
      }, label), React.createElement(TriggerWrapper, null, React.createElement(Trigger, {
        as: ClearedButton,
        isInvalid: !!errorText,
        disabled: disabled,
        onClick: onClick,
        onFocus: this.handleBtnFocus,
        "aria-labelledby": "".concat(id, "-label"),
        tabIndex: -1,
        "aria-hidden": true,
        id: id,
        showClearIcon: showClearIcon
      }, React.createElement(ValueWrapper, null, value || React.createElement(Placeholder, null, placeholder))), React.createElement(ActionsWrapper, null, showClearIcon && React.createElement(ClearButton, {
        onClick: onClear,
        inputId: id,
        label: label
      }), React.createElement(TriggerButton, Object.assign({
        "aria-labelledby": "".concat(id, "-label"),
        selectedValue: value,
        id: "".concat(id, "-arrow"),
        title: title,
        onClick: onClick
      }, btnProps)))));
    }
  }]);

  return SelectTrigger;
}(Component);
SelectTrigger.defaultProps = {
  onClick: function onClick() {
    return null;
  },
  onClear: function onClear() {
    return null;
  },
  clearable: false,
  disabled: false,
  hiddenLabel: false
};